import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { reducers, metaReducers } from 'src/app/store/metaReducers';
import { metaEffects } from 'src/app/store/metaEffects';
import { environment } from 'src/environments/environment';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';

import * as msalConfigs from './msal.config';
import { NavigationInterceptorHelper } from 'src/app/domains/shared';
import { CustomInterceptor } from './interceptors/custom-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withHashLocation()),

   /* NGRX */
    provideStore(reducers, { metaReducers }),
    provideEffects(...metaEffects),
    provideStoreDevtools({ maxAge: 100, logOnly: environment.production }),

    /* MSAL */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: msalConfigs.UsersMSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: msalConfigs.UsersMSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalConfigs.MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true
    },

    MsalService,
    MsalGuard,
    MsalBroadcastService, 

    {
      provide: APP_INITIALIZER,
      useFactory: (hashFixService: NavigationInterceptorHelper) => () => {

        /* console.log(hashFixService); */

        return Promise.resolve();
      },
      deps: [NavigationInterceptorHelper],
      multi: true
    } 
  ]
};
